import styled, { css } from "styled-components";
import { useNavigate } from "react-router-dom";

// import { Default } from "Types";

import AtomTitle from "Components/Atoms/Title";
import OrganismStep4Message from "Components/Molecules/Step4Message";
import OrganismSteps from "Components/Organisms/Steps";
import AtomButton from "Components/Atoms/Button";

export type PropsType = any;

const Wrap = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
`;

const Message = styled(OrganismStep4Message)`
   margin-top: 69px;
`;
const Button = styled(AtomButton)``;
const Steps = styled(OrganismSteps)`
   margin-top: 45px;
`;

export default function TemplateStep3(props: PropsType) {
   const navigate = useNavigate();
   function backOnClik() {
      navigate("/steps/1");
   }
   function goOnClik() {
      navigate("/steps/5");
   }
   return (
      <Wrap>
         <AtomTitle>전시회 등록</AtomTitle>
         <Steps step={4}></Steps>
         <Message></Message>
         <Button
            onClick={backOnClik}
            css={css`
               margin-top: 86px;
            `}>
            한번 더 확인해볼게요
         </Button>
         <Button
            onClick={goOnClik}
            css={css`
               margin-top: 10px;
            `}>
            네, 완료하겠습니다
         </Button>
      </Wrap>
   );
}
